import React from 'react';
import { Alerta, TipoAlerta, Row, Box, Botao, TipoBotao, Col, Combo } from '@intechprev/componentes-web';
import { MasterPage } from "..";
import { FormulariosService, PlanoService } from '../../services';
import { NumFuncionalidade } from '../MasterPage';
import { reCAPTCHA } from '../../helpers';
import { PlanoVinculadoEntidade } from '../../entidades';

interface Props { };

interface State { };

export class Formularios extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("formularios");

  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  state = {
    planos: [new PlanoVinculadoEntidade()],
    plano: new PlanoVinculadoEntidade(),
    cdPlano: "",
    processosBeneficio: {},
    processo: {},
    especieAnoNumProcesso: ""
  };

  constructor(props: Props) {
    super(props);
  }

  componentDidMount = async () => {
    try {
      var planos = await PlanoService.Buscar();

      var plano = planos[0];

      var cdPlano = plano.CD_PLANO;

      await this.setState({
        planos: planos,
        plano: plano,
        cdPlano: cdPlano,
        processosBeneficio: {},
        processo: {},
        especieAnoNumProcesso: ""
      });

      console.log(this.state)
    }
    catch (err) {
      console.error(err);
    }
  }

  carregarPlano = async () => {
    //await this.page.current.alternarLoading();

    var plano = null;
    var cdPlano = "";

    if (this.state.cdPlano)
      plano = this.state.planos.filter((plano: any) => plano.CD_PLANO === this.state.cdPlano)[0];
    else plano = this.state.planos[0];

    cdPlano = plano.CD_PLANO;

    await this.setState({
      plano,
      cdPlano,
    });
    //await this.page.current.alternarLoading();
  };

  GerarRelatorioAdesaoContratoAberturaCredito = async () => {
    try {
      await this.alerta.current!.limparErros();
      const relatorio = await FormulariosService.GetRelatorioAdesaoContratoAberturaCredito(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "adesao_contrato_abertura_credito.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'adesao_contrato_abertura_credito.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  gerarRelatorioAtualizacaoDadosBancarios = async () => {
    try {
      await this.alerta.current!.limparErros();
      const relatorio = await FormulariosService.GetRelatorioAtualizacaoDadosBancarios(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "atualizacao_dados_bancarios.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'atualizacao_dados_bancarios.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  GerarRelatorioDeclaracaoDeDepedencia = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioDeclaracaoDeDepedencia(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "declaracao_de_depedencia.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'declaracao_de_depedencia.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  GerarRelatorioDesignicaoBeneficiarioParticipanteAdmitido = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioDesignicaoBeneficiarioParticipanteAdmitido(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "designacao_beneficiario_participante_admitido.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'designacao_beneficiario_participante_admitido.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      if (err.response) {
        await this.alerta.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  GerarRelatorioAlteracaoPercentualPlanoB = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioAlteracaoPercentualPlanoB(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "alteracao_percentual_planoB.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'alteracao_percentual_planoB.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      if (err.response) {
        await this.alerta.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  GerarRelatorioInclusaoExclusaoPensaoPorMorte = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioInclusaoExclusaoPensaoPorMorte(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "inclusao_exclusao_pensao_por_morte.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'inclusao_exclusao_pensao_por_morte.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      if (err.response) {
        await this.alerta.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  GerarRelatorioSolicitacaoEmprestimo = async () => {
    try {
      await this.alerta.current!.limparErros();

      const relatorio = await FormulariosService.GetRelatorioSolicitacaoEmprestimo(false);

      if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "solicitacao_emprestimo.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'solicitacao_emprestimo.pdf');
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      if (err.response) {
        await this.alerta.current!.adicionarErro(await err.response.data.text());
        console.error(await err.response.data.text());
        return;
      }
      await this.alerta.current!.adicionarErro(err);
      console.error(err);
    }
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.FORMULARIOS} {...this.props} ref={this.page}>
        {this.state.planos.length > 1 && (
          <Combo
            contexto={this}
            titulo={"Selecione um plano"}
            onChange={this.carregarPlano}
            nome={"cdPlano"}
            valor={this.state.cdPlano}
            opcoes={this.state.planos}
            nomeMembro={"DS_PLANO"}
            valorMembro={"CD_PLANO"}
            obrigatorio
            padrao={this.state.cdPlano}
          />
        )}
        <Box>
          <Row>
            <Col>
              <Botao
                tipo={TipoBotao.link}
                titulo={"Atualização de Dados Bancários"}
                icone={"fa-file-pdf"}
                usaLoading
                onClick={this.gerarRelatorioAtualizacaoDadosBancarios}
                style={{ "text-align": "left" }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Botao
                tipo={TipoBotao.link}
                titulo={"Declaração de Dependência para Fins de Desconto do IR"}
                icone={"fa-file-pdf"}
                usaLoading
                onClick={this.GerarRelatorioDeclaracaoDeDepedencia}
                style={{ "text-align": "left" }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Botao
                tipo={TipoBotao.link}
                titulo={"Designação de Beneficiários - Pecúlio"}
                icone={"fa-file-pdf"}
                usaLoading
                onClick={this.GerarRelatorioDesignicaoBeneficiarioParticipanteAdmitido}
                style={{ "text-align": "left" }}
              />
            </Col>
          </Row>

          {this.state.cdPlano === "0002" && (
            <>
              <Row>
                <Col>
                  <Botao
                    tipo={TipoBotao.link}
                    titulo={"Solicitação de Alteração de Percentual Contribuição para RMV - Plano B"}
                    icone={"fa-file-pdf"}
                    usaLoading
                    onClick={this.GerarRelatorioAlteracaoPercentualPlanoB}
                    style={{ "text-align": "left" }}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Botao
                    tipo={TipoBotao.link}
                    titulo={"Solicitação de Inclusão_Exclusão de Pensão por Morte e Dependentes"}
                    icone={"fa-file-pdf"}
                    usaLoading
                    onClick={this.GerarRelatorioInclusaoExclusaoPensaoPorMorte}
                    style={{ "text-align": "left" }}
                  />
                </Col>
              </Row>
            </>
          )}

          <Row>
            <Col>
              <Botao
                tipo={TipoBotao.link}
                titulo={"Termo de Adesão ao Contrato de Abertura de Crédito vf"}
                icone={"fa-file-pdf"}
                usaLoading
                onClick={this.GerarRelatorioAdesaoContratoAberturaCredito}
                style={{ "text-align": "left" }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Botao
                tipo={TipoBotao.link}
                titulo={"Solicitação de Empréstimo"}
                icone={"fa-file-pdf"}
                usaLoading
                onClick={this.GerarRelatorioSolicitacaoEmprestimo}
                style={{ "text-align": "left" }}
              />
            </Col>
          </Row>

          <Alerta tipo={TipoAlerta.danger} ref={this.alerta} />
        </Box>
      </MasterPage>
    );
  }
}